// src/modules/appointments/components/AppointmentResourcesManager.jsx
import { useState } from "react";

export default function AppointmentResourcesManager({
  appointment,
  onAdd,
  onRemove,
}) {
  const [resourceId, setResourceId] = useState("");
  const [role, setRole] = useState("");

  const resources = appointment?.resources || [];

  async function handleAdd(e) {
    e.preventDefault();
    if (!resourceId) return;
    onAdd &&
      onAdd({
        resource_id: Number(resourceId),
        role: role || null,
      });
    setResourceId("");
    setRole("");
  }

  return (
    <div className="mt-4 border rounded p-3">
      <div className="font-semibold text-xs mb-2">Recursos asignados</div>
      {resources.length ? (
        <ul className="text-xs mb-3">
          {resources.map((r) => (
            <li
              key={r.id || `${r.resource_id}-${r.role}`}
              className="flex justify-between items-center py-1 border-b last:border-b-0"
            >
              <span>
                #{r.resource_id} - {r.name}{" "}
                {r.role && <span className="text-gray-500">({r.role})</span>}
              </span>
              <button
                onClick={() => onRemove && onRemove(r.resource_id)}
                className="text-red-500 hover:underline"
              >
                Quitar
              </button>
            </li>
          ))}
        </ul>
      ) : (
        <div className="text-xs text-gray-500 mb-2">
          No hay recursos asignados.
        </div>
      )}

      <form onSubmit={handleAdd} className="flex gap-2 text-xs">
        <input
          type="number"
          placeholder="ID recurso"
          value={resourceId}
          onChange={(e) => setResourceId(e.target.value)}
          className="border rounded px-2 py-1 w-28"
        />
        <input
          type="text"
          placeholder="Rol (opcional)"
          value={role}
          onChange={(e) => setRole(e.target.value)}
          className="border rounded px-2 py-1 flex-1"
        />
        <button
          type="submit"
          className="px-3 py-1 rounded bg-gray-800 text-white"
        >
          Agregar
        </button>
      </form>
    </div>
  );
}
